import React from 'react';
import { Route, Switch } from 'react-router-dom';

import ReviewScreen from './Review';
import SuccessScreen from './Success';
import PassengerDetailsScreen from './PassengerDetails';
import SearchAndResultsScreen from './SearchAndResults';

import './Flights.css';

export const FlightPageContext = React.createContext();

const PageContext = {
  '/flights': 'everest',
  '/flights/all': 'all',
  '/flights/pokhara-to-jomsom-online-flight-booking': 'jomsom',
  '/flights/ramechhap-to-lukla-online-flight-booking': 'ramechhap',
  // '/flights/kathmandu-to-pokhara-online-flight-booking': 'pokhara',
};

export default function FlightsScreen(props) {
  const {
    match: { path: frontUrl },
  } = props;

  return (
    <Switch>
      <FlightPageContext.Provider value={PageContext[frontUrl]}>
        <Route exact path={frontUrl} component={SearchAndResultsScreen} />

          <Route
            exact
            path={`${frontUrl}/passenger-details`}
            component={PassengerDetailsScreen}
            />

          <Route
            exact
            path={`${frontUrl}/details-review/:invoiceId`}
            component={ReviewScreen}
          />

        <Route
          exact
          path={`${frontUrl}/booking-success`}
          component={SuccessScreen}
        />
      </FlightPageContext.Provider>
    </Switch>
  );
}



// WEBPACK FOOTER //
// ./src/screens/Flights/FlightsScreen.js